import type { FichaFieldNotice } from '../lib/fichaFieldLimits';

export function FichaFieldNotices({ notices }: { notices: FichaFieldNotice[] }) {
    if (!notices.length) return null;
    return (
        <>
            {notices.map((notice) => (
                <p
                    key={`${notice.level}-${notice.message}`}
                    className={
                        notice.level === 'block'
                            ? 'text-[11px] text-destructive'
                            : 'text-[11px] text-amber-900 dark:text-amber-200'
                    }
                >
                    {notice.message}
                </p>
            ))}
        </>
    );
}
